<script setup lang="ts">
const tab = defineModel()
</script>

<template>
  <VTabs class="mb-6" v-model="tab">
    <VTab value="">{{ $t('itf.main') }}</VTab>
    <VTab value="notifications">{{ $t('itf.notifications') }}</VTab>
    <VTab value="subscribes">{{ $t('itf.subscribes') }}</VTab>
  </VTabs>
</template>
